import React, { Component } from 'react';
import { TechnicalBreak } from 'features';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(error, info);
  }

  render() {
    if (this.state.hasError) {
      return <TechnicalBreak />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
